import { toggleExpandedFavoritesSidebar } from "_sirius/src/actions/general_actions";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSidebarStore, { PannelEnum } from "./sidebarStore";

/**
 * Brings Sirius Chat on screen.
 *
 * Selecting the chat panel is not enough: a collapsed sidebar is translated
 * off-screen (`main-sidebar--hidden`), and the collapsed state is persisted,
 * so an action that only switches the panel appears to do nothing at all.
 * Expand it too when it is closed.
 */
export function useOpenChatPanel() {
  const setCurrentPanel = useSidebarStore(s => s.setCurrentPanel);
  const expanded = useSelector(
    (state: { app: { favoritesSidebarExpanded: boolean } }) =>
      state.app.favoritesSidebarExpanded
  );
  const dispatch = useDispatch();

  return useCallback(() => {
    setCurrentPanel(PannelEnum.RangerChat);
    if (!expanded) dispatch(toggleExpandedFavoritesSidebar());
  }, [setCurrentPanel, expanded, dispatch]);
}
